import type {
  ConnectionConfig,
  ConnectionStatus,
  InventorySyncConnection,
  TerminusType,
} from '../../../../../inventory-sync/types/inventory-sync-types';

export const SYNC_INELIGIBLE_REASON = {
  notATarget: 'NotATarget',
  targetUnsupported: 'TargetUnsupported',
} as const;

export type SyncIneligibleReason = (typeof SYNC_INELIGIBLE_REASON)[keyof typeof SYNC_INELIGIBLE_REASON];

const SYNC_INELIGIBLE_REASONS: readonly string[] = Object.values(SYNC_INELIGIBLE_REASON);

export const toSyncIneligibleReason = (reason: string | null | undefined): SyncIneligibleReason | null =>
  reason && SYNC_INELIGIBLE_REASONS.includes(reason) ? (reason as SyncIneligibleReason) : null;

export type ProductConnectionSyncRow = {
  connectionId: string;
  connectionName: string;
  apiCode: string;
  terminusType: TerminusType;
  connectionStatus: ConnectionStatus;
  ineligibleReason: SyncIneligibleReason | null;
  lastSyncedAt: string | null;
  lastSyncedQuantity: number | null;
  nextSyncQuantity: number | null;
  config: ConnectionConfig;
  isSyncing: boolean;
  hasSyncError: boolean;
  syncErrorMessage: string | null;
  connection: InventorySyncConnection | null;
};

export type ProductSyncSummary = {
  inStockQuantity: number | null;
  lastUpdatedAt: string | null;
};
